// extracted by mini-css-extract-plugin
module.exports = {"bgPrimary":"styles_bgPrimary__12Knu","bg-secondary":"styles_bg-secondary__3n4Gd"};